import { connect } from 'react-redux';
import UangPendaftaranPPDB from '../../views/Settings/UangPendaftaranPPDB.view';
import { getUsernameOptions, getUserGroups, getSchoolUnitsOptions } from '../../states/thunks/options.thunk';
import { listUangPendaftaranPPDB, saveUangPendaftaranPPDB } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListUangPendaftaranPPDB: (payload, goback) => dispatch(listUangPendaftaranPPDB(payload, goback)),
    getUsernameOptions: payload => dispatch(getUsernameOptions(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    handleSaveUangPendaftaranPPDB: (payload, goback) => dispatch(saveUangPendaftaranPPDB(payload, goback)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UangPendaftaranPPDB);
